import { LinkOutlined } from '@mui/icons-material';
import { Box, IconButton, Link } from '@mui/material';
import React, { forwardRef, Ref } from 'react';
import { IeLynxObject } from "../../common/models/eLynxObject";
import { useUserContext } from '../../contexts/user-context/UserContext';
import { useRouteContext } from "../../hooks/use-route-context/UseRouteContext";
import { useObjectViewState } from "../../queries/object-view-state/UseObjectViewState";
import { useQueryNotifications } from '../../queries/UseQueryNotifications';
import { ContentContainer } from '../content-container/ContentContainer';
import { ContentSection } from '../content-section/ContentSection';

export type ObjectExternalConentProps = {
    visible?: boolean;
};

export type ObjectExternalContentType = {
    //executeAction: (action: ObjectActionEnum | BaseActionEnum) => void;
};

function ObjectExternalContent({
    visible,
}: ObjectExternalConentProps, ref: Ref<unknown> | undefined) {

    const [userState] = useUserContext();
    const routeContext = useRouteContext();

    const { data: objectViewState } = useQueryNotifications(useObjectViewState)({
        customerID: userState.customer?.id as number,
        groupID: routeContext.groupID as number,
        contextObject: {...routeContext.contextObject as IeLynxObject
        },
        offline: false
    });

    return (

            visible && objectViewState?.externalContent?.url ?
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        flexGrow: 1,
                        overflow: "hidden",
                    }}>

                        <ContentContainer>
                            <ContentSection>

                               

                                    
                                <Box sx={{
                                    display: 'flex',
                                    justifyContent: 'flex-end'
                                }}>
                                    <Link href={objectViewState.externalContent.url} target="_blank">
                                        <IconButton component="span" size='medium'>
                                            <LinkOutlined fontSize='large' />
                                        </IconButton>
                                    </Link>
                                </Box>

                             {/* https://blog.bitsrc.io/best-practices-in-using-iframes-with-react-6193feaa1e08, since 
                                we only allow private ips when adding external content urls then assuming that we will
                                trust the iframe source.  Cannot really use sandbox because we are doing more than just embedding
                                content for display purposes, the iframe source will likely need to execute javascript. */}
                                    <Box
                                        sx={{
                                            display: "flex",
                                            flexDirection: "column",
                                            flexGrow: 1,
                                            overflow: "hidden"
                                        }}
                                     dangerouslySetInnerHTML={{ 
                                        __html: `<iframe src='${objectViewState.externalContent.url}' frameBorder="0" style='height: 100%; width: 100%; border=none;' />`}} 
                                    />


                            </ContentSection>

                            
                        </ContentContainer>
                </Box>
                : null
    );
}

export default forwardRef(ObjectExternalContent);